module.exports = __webpack_public_path__ + "static/media/BuildingSMART_CMYK_Germany_350.cc28aa35.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/BuildingSMART_CMYK_Germany_350.jpeg
// module id = 603
// module chunks = 0